export default  {
    component: 'relay',
    name: 'relay',
    fields: [
        {
            param: 'plant_id',
            type: 'number',
            required: true,
            identifier: true,
            hidden: true
          },
          {
            name: 'Block ID',
            param: 'block_id',
            type: 'number',
            required: true,
            identifier: true,
            description: `> Should always start from ID **"1"**`
          },
          {
            name: 'Relay ID',
            param: 'relay_id',
            type: 'number',
            required: true,
            identifier: true,
            description: `> For each Block, relay id should start from **"1"**`
          },
          {
            name: 'Device ID',
            param: 'device_id',
            type: 'number',
            required: true,
            identifier: true,
            description: `The concatination for devices are added *\(e.g 1-1)`
          },
          {
            name: 'Relay Name',
            param: 'relay_name',
            type: 'text',
            description: `> For each block relay name should be unique`
          },
          {
            name: 'Reading frequency',
            param: 'reading_frequency',
            type: 'number',
            description: `It varies from plants few we recieve data at interval of 5 min so we need to add frequency as **"5"** in order to show connectivity in graph.`
          },
          {
            name: 'Latitude',
            param: 'latitude',
            type: 'number',
          },
          {
            name: 'Longitude',
            param: 'longitude',
            type: 'number',
          },
          {
            name: 'Param Config',
            param: 'param_config',
            type: 'json',
          },
          {
            name: 'Parameter List',
            param: 'param_list',
            type: 'text',
            description: `In order to remove unwanted parameters from analytics. *\(e.g rm-efficiency,em-voltage_supply)`
          },
          {
            name: 'Make',
            param: 'make',
            type: 'text',
          },
          {
            name: 'Name Config',
            param: 'name_config',
            type: 'text',
            description: `The name should be unique. Name Concatination of Block Name-Room Name-Device Name`
          }
    ]
  }






